// Shows a listed discount code's prices on product cards and pages as soon as the page's prices have
// been parsed. The script is loaded right after <main>, ahead of the deferred scripts, so a shopper
// arriving with a code never sees the full price first. Discounts in js_main.js takes these methods
// over for the cart, and syncs the code with Shopify's cart once the page has loaded.

// The theme's money formatter, also used by js_main.js
theme.Currency = (function() {
  var moneyFormat = '${{amount}}'; // eslint-disable-line camelcase

  function formatMoney(cents, format, round) {

    if (typeof cents === 'string') {
      cents = cents.replace('.', '');
    }
    if (round) cents = Math.round(cents / 100) * 100;
    var value = '';
    var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
    var formatString = (format || moneyFormat);

    function formatWithDelimiters(number, precision, thousands, decimal) {

    	if ( precision != undefined ) {
    		precision = precision;
    	} else {
    		precision = 2;
    	}

      thousands = thousands || ',';
      decimal = decimal || '.';


      if (isNaN(number) || number == null) {
        return 0;
      }

      if (round) precision = 0;
      number = (number / 100.0).toFixed(precision);

      var parts = number.split('.');
      var dollarsAmount = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
      var centsAmount = parts[1] ? (decimal + parts[1]) : '';

      return dollarsAmount + centsAmount;
    }

    switch (formatString.match(placeholderRegex)[1]) {
      case 'amount':
        value = formatWithDelimiters(cents, 2);
        break;
        case 'savings':
        value = formatWithDelimiters(cents, 0);
        break;
      case 'amount_no_decimals':
        value = formatWithDelimiters(cents, 0);
        break;
      case 'amount_with_comma_separator':
        value = formatWithDelimiters(cents, 2, '.', ',');
        break;
      case 'amount_no_decimals_with_comma_separator':
        value = formatWithDelimiters(cents, 0, '.', ',');
        break;
      case 'amount_no_decimals_with_space_separator':
        value = formatWithDelimiters(cents, 0, ' ');
        break;
      case 'amount_with_space_separator':
        value = formatWithDelimiters(cents, 2, ' ', ',');
        break;
      case 'amount_with_period_and_space_separator':
        value = formatWithDelimiters(cents, 2, ' ', '.');
        break;
      case 'amount_with_apostrophe_separator':
        value = formatWithDelimiters(cents, 2, "'", '.');
        break;
    }

    return formatString.replace(placeholderRegex, value);
  }

  return {
    formatMoney: formatMoney
  }
})();

class DiscountPrices {
    checkDiscount(discountCode) {		
		this.currentDiscount = this.discounts[discountCode];
		return this.currentDiscount ? true : false;
    }

    setDiscounts() {	
		this.checkCondition();
		
		if (!this.conditionMeet) {
			this.removePriceDiscounts();
			this.removeWrittenDiscounts();
			this.setPriceOnOneMoreProducts();

		} else {
			this.setPriceDiscounts();
			this.setWrittenDiscounts();
		}
    }

	checkCondition() {
		this.conditionMeet = false;
		this.currentCodeX = false;
		this.oneMoreTillDiscount = [];
		this.dontApplyOn = this.currentDiscount?.dont_apply_discounts_on || [];		
				
		if (!this.currentDiscount) return;
		if (!this.currentDiscount.use_minimum_list_x && !this.currentDiscount.use_minimum_cart && !this.currentDiscount.use_minimum_list)
			return this.conditionMeet = true;

		const cart = document.querySelector("#site-nav--mobile") || document.querySelector("#section-cart");
		const cartItems = Array.from(cart.querySelectorAll("cart-drawer .cart-item"));
		const idsInCart = cartItems.map(item => item.dataset.variantId);		

		/**************************************** product list x condition ****************************************/
		if (this.currentDiscount.use_minimum_list_x) {
			const { product_list_x: conditionIds, minimum_list_x: minimumAmount } = this.currentDiscount;

			const filteredList = idsInCart.filter(id => conditionIds.includes(id));
			const totalQuantity = this.calculateTotalQuantity(filteredList); 	
				
			if (totalQuantity >= minimumAmount) {
				this.conditionMeet = true;
				this.currentCodeX = true;
			} 
		}

		/**************************************** amount condition ****************************************/ 
		if (this.currentDiscount.use_minimum_cart) {
			const minimumAmount = this.currentDiscount.minimum_cart;
			const cartAmount = Number(document.querySelector(".CartMain").dataset.quantityTotal);

			// Prices on the page show what a product costs once it's added, so it counts toward the minimum
			if (cartAmount + 1 >= minimumAmount) this.conditionMeet = true;
		}

		/**************************************** product list condition ****************************************/
		if (this.currentDiscount.use_minimum_list) {			
			const { product_list: conditionIds, minimum_list: minimumAmount } = this.currentDiscount;
			const filteredList = idsInCart.filter(id => conditionIds.includes(id));
			const totalQuantity = this.calculateTotalQuantity(filteredList);

			if (totalQuantity >= minimumAmount) {
				this.conditionMeet = true;
				this.showUpsellMsg(filteredList);
			} else if (totalQuantity === minimumAmount - 1) {
				this.showUpsellMsg(filteredList);
				this.oneMoreTillDiscount = this.oneMoreTillDiscount.concat(conditionIds);
			} else {
				this.hideUpsellMsg();
			}
		}		
	}

	// Helper to calculate the total quantity of matching items in the cart
	calculateTotalQuantity(filteredIds) {
		return filteredIds
			.map(id => parseFloat(document.querySelector(`.cart-item[data-variant-id="${id}"]`).dataset.itemAmount))
			.reduce((sum, amount) => sum + amount, 0);
	}

	showUpsellMsg(idsInCart) {						
		const productId = idsInCart[0];
		const msg = document.querySelector(`.discount_2nd_item[data-variant-id="${productId}"]`);
		
		if (!msg) return;

		//const discount = this.currentDiscount.amount;
		const item = document.querySelector(`.cart-item[data-variant-id="${productId}"]`);
		if (!item) return msg.classList.remove("flow-in");

		const priceElem = item.querySelector(".cart__item-price");
		let price = priceElem.dataset.originalPrice;
		let compare = priceElem.dataset.comparePrice || price;

		price = Math.round(price - price * (this.currentDiscount.amount / 100));		
		
		const discount = Math.round((1 - price / compare) * 100);
		
		const msg_text = msg.querySelector("span");
		msg_text.innerText = window.theme.flyInDiscountFirst + " " + discount + window.theme.flyInDiscountSecond;

		msg.classList.add("flow-in");
	}

	hideUpsellMsg() {
		const msgs = document.querySelectorAll(`.discount_2nd_item.flow-in`);
		msgs.forEach(msg => {
			msg.classList.remove("flow-in")
		})
	}

	setPriceOnOneMoreProducts() {		
		if (!this.oneMoreTillDiscount.length) return;

		let priceElems = [], writtenDiscountElems = [];

		this.oneMoreTillDiscount.forEach(id => {
			const tempPriceElems = document.querySelectorAll(`[data-variant-id="${id}"][data-override-value]`);
			if (tempPriceElems.length) priceElems = priceElems.concat(Array.from(tempPriceElems));

			const tempWrittenDiscountElems = document.querySelectorAll(`.Discount__Regular[data-variant-id="${id}"]`);
			if (tempWrittenDiscountElems.length) writtenDiscountElems = writtenDiscountElems.concat(Array.from(tempWrittenDiscountElems));
		})
		
		const oneMore = true;
		this.setPriceDiscounts(priceElems);
		this.setWrittenDiscounts(writtenDiscountElems, oneMore);
	}

	setPriceDiscounts(priceElems) {				
		priceElems = priceElems || document.querySelectorAll('[data-override-value]');

		priceElems.forEach(priceElem => {
			const id = priceElem.dataset.variantId;

			if (!this.dontApplyOn.includes(id)) {				
				const parent = priceElem.parentElement.parentElement;
				const compareElem = parent.querySelector("[data-override-compare]");
	
				const price = this.currentDiscount.discount_from_compare ? compareElem.dataset.overrideCompare || priceElem.dataset.overrideValue : priceElem.dataset.overrideValue;
				const comparePrice = compareElem.dataset.overrideCompare || priceElem.dataset.overrideValue;
					
				let newCompare = theme.Currency.formatMoney(comparePrice, window.shop_money_format);
				const bundleUnit = compareElem.dataset.bundleUnit;
				if (bundleUnit) newCompare = newCompare + bundleUnit;
	
				compareElem.innerText = newCompare;
	
				this.calculateDiscount(priceElem, price);
			}
		})
	}

	removePriceDiscounts() {
		const priceElems = document.querySelectorAll("[data-override-value]");

		priceElems.forEach(priceElem => {
			const parent = priceElem.parentElement.parentElement;
			const compareElem = parent.querySelector("[data-override-compare]");

			const price = priceElem.dataset.overrideValue;
			const compare = compareElem.dataset.overrideCompare;

			if (compare === price || !compare) compareElem.innerText = "";

			this.resetPrice(priceElem, price);
		})
	}

	calculateDiscount(item, price) {		
		if (!item || !price) return;
		
		const discountedPrice = price * ((100 - this.currentDiscount.amount) / 100);
		const newPrice = theme.Currency.formatMoney(Math.ceil(discountedPrice), window.shop_money_format);
		const unit = item.dataset.bundleUnit || "";
		
		item.setAttribute("data-active-discount", this.currentDiscount.code);
		item.setAttribute("data-price-after-discount", Math.ceil(discountedPrice));

		item.innerText = newPrice + unit;
	}

	resetPrice(item, price) {
		if (!item || !price) return;
		
		const newPrice = theme.Currency.formatMoney(price, window.shop_money_format);
		item.removeAttribute("data-active-discount");
		item.setAttribute("data-price-after-discount", price);

		const unit = item.dataset.bundleUnit || "";
		item.innerText = newPrice + unit;
	}

	setWrittenDiscounts(discounts) {
		let oneMore = false;

		if (discounts) oneMore = true;
		discounts = discounts || document.querySelectorAll(`.Discount__Regular:not([data-active-discount="${this.currentDiscount.code}"])`);		

		discounts.forEach(item => {
			const id = item.dataset.variantId;

			if (!this.dontApplyOn.includes(id)) {
				this.calculateWrittenDiscount(item, oneMore);
			}
		})
	}

	removeWrittenDiscounts() {
		let oneMore = false;
		const discount = document.querySelectorAll(`.Discount__Regular`);

		discount.forEach(item => {
			this.calculateWrittenDiscount(item, oneMore);
		})
	}

	calculateWrittenDiscount(item, oneMore) {				
		const svg = `<svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
			<path fill-rule="evenodd" clip-rule="evenodd" d="M2.48202 13.0409L1.55745 12.4917C1.14802 12.2485 0.894693 11.8097 0.888795 11.3336L0.875477 10.2583C0.872647 10.0298 0.812608 9.80578 0.700848 9.60654L0.174734 8.66865C-0.0582446 8.25332 -0.0582446 7.74668 0.174734 7.33135L0.700848 6.39346C0.812608 6.19422 0.872647 5.97015 0.875477 5.74173L0.888795 4.66644C0.894693 4.19026 1.14802 3.75149 1.55745 3.5083L2.48202 2.95912C2.67842 2.84245 2.84245 2.67842 2.95912 2.48202L3.5083 1.55745C3.75149 1.14802 4.19026 0.894693 4.66644 0.888795L5.74173 0.875477C5.97015 0.872647 6.19422 0.812608 6.39346 0.700848L7.33135 0.174734C7.74668 -0.0582446 8.25332 -0.0582446 8.66865 0.174734L9.60654 0.700848C9.80578 0.812608 10.0298 0.872647 10.2583 0.875477L11.3336 0.888795C11.8097 0.894693 12.2485 1.14802 12.4917 1.55745L13.0409 2.48202C13.1575 2.67842 13.3216 2.84245 13.518 2.95912L14.4426 3.5083C14.852 3.75149 15.1053 4.19026 15.1112 4.66644L15.1245 5.74173C15.1274 5.97015 15.1874 6.19422 15.2992 6.39346L15.8253 7.33135C16.0582 7.74668 16.0582 8.25332 15.8253 8.66865L15.2992 9.60654C15.1874 9.80578 15.1274 10.0298 15.1245 10.2583L15.1112 11.3336C15.1053 11.8097 14.852 12.2485 14.4426 12.4917L13.518 13.0409C13.3216 13.1575 13.1575 13.3216 13.0409 13.518L12.4917 14.4426C12.2485 14.852 11.8097 15.1053 11.3336 15.1112L10.2583 15.1245C10.0298 15.1274 9.80578 15.1874 9.60654 15.2992L8.66865 15.8253C8.25332 16.0582 7.74668 16.0582 7.33135 15.8253L6.39346 15.2992C6.19422 15.1874 5.97015 15.1274 5.74173 15.1245L4.66644 15.1112C4.19026 15.1053 3.75149 14.852 3.5083 14.4426L2.95912 13.518C2.84245 13.3216 2.67842 13.1575 2.48202 13.0409ZM5.27988 10.1782C5.03729 10.4673 5.075 10.8983 5.36411 11.1409C5.65323 11.3835 6.08426 11.3458 6.32686 11.0567L10.7194 5.82183C10.962 5.53271 10.9243 5.10168 10.6352 4.85908C10.3461 4.61649 9.91505 4.6542 9.67245 4.94331L5.27988 10.1782ZM6.55002 6.55037C7.08376 6.01663 7.08376 5.15127 6.55002 4.61753C6.01629 4.08379 5.15092 4.08379 4.61718 4.61753C4.08344 5.15127 4.08344 6.01663 4.61718 6.55037C5.15092 7.08411 6.01629 7.08411 6.55002 6.55037ZM11.3821 11.3825C11.9159 10.8487 11.9159 9.98337 11.3821 9.44963C10.8484 8.91589 9.98302 8.91589 9.44929 9.44963C8.91555 9.98337 8.91555 10.8487 9.44929 11.3825C9.98302 11.9162 10.8484 11.9162 11.3821 11.3825Z" fill="#F80B00"></path>
			</svg>`;

		const id = item.dataset.variantId;

		// this needs to be changed so that it only fetches price from closest wrapper 
		let priceElem = document.querySelector(`[data-variant-id="${id}"][data-override-value]`);
		let compareElem = document.querySelector(`[data-variant-id="${id}"][data-override-compare]`);

		const pdpWrapper = item.closest(".pdp_priceWrapper");
		if (pdpWrapper) {
			priceElem = pdpWrapper.querySelector(`[data-variant-id="${id}"][data-override-value]`);
			compareElem = pdpWrapper.querySelector(`[data-variant-id="${id}"][data-override-compare]`);
		}

		if (!priceElem) return;
		
		let price = priceElem.dataset.overrideValue;
		let compare = compareElem?.dataset.overrideCompare;
		let compareHidden = false;

		if (!compare) {			
			compare = price;
			compareHidden = true;
		}

		price = Number(price);
		compare = Number(compare);

		const fromCompare = this.currentDiscount?.discount_from_compare;

		if (fromCompare && this.conditionMeet) price = compare;
		if (this.conditionMeet || oneMore) price = price * ((100 - this.currentDiscount.amount) / 100);
				
		const discountAmount = item.querySelector(".discount__amount");
		if (!discountAmount) return console.log(item, "Should have discount amount");
		
		const usePercent = discountAmount.classList.contains("discount__amount-percentage")
		let string = "", newDiscountAmount = "";	

		if (usePercent) {
			newDiscountAmount = Math.round((1 - price / compare) * 100);
			string = compareHidden && !this.conditionMeet && !oneMore ? "" : svg + newDiscountAmount + "% " + window.theme.discountsOffString;
			
		} else {
			newDiscountAmount = (compare - price);

			const bundleQuantity = discountAmount.dataset.bundleQuantity;
			if (bundleQuantity) newDiscountAmount *= Number(bundleQuantity);

			const discountAfterFormat = theme.Currency.formatMoney(newDiscountAmount, window.shop_money_format, true);

			string = compareHidden && !this.conditionMeet && !oneMore ? "" : svg + window.theme.discountsSaveString + " " + discountAfterFormat;
		}		
		
		if (newDiscountAmount === 0) string = "";
		discountAmount.innerHTML = string;

		if (this.currentDiscount && this.conditionMeet) item.setAttribute("data-active-discount", this.currentDiscount.code);
		else item.removeAttribute("data-active-discount");
	}
}

// Shows the prices for the code the page was opened with: a ?discount= link's, the cart's, or one saved
// from an earlier page. Prices stay hidden until then (see the discount-pending class in theme.liquid).
(function() {
	try {
		const code = theme.pageDiscountCode();
		if (!code) return;

		const prices = new DiscountPrices();
		prices.discounts = theme.discountCodes;
		if (prices.checkDiscount(code) || prices.checkDiscount(code.replace(/x$/, ""))) prices.setDiscounts();
	} finally {
		document.documentElement.classList.remove("discount-pending");
	}
})();
